import moment from 'moment';

// May 12, 2026 UTC
export const MEMBERSHIP_CUTOFF_DATE = moment('2026-05-12T00:00:00Z');

/**
 * Checks if a user requires a membership subscription.
 * An authenticated user requires membership if:
 * 1. Their account was created on or after the MEMBERSHIP_CUTOFF_DATE.
 * 2. They do not have an active subscription (membership_active !== true).
 *
 * @param {Object} currentUser
 * @returns {boolean}
 */
export const requiresMembership = currentUser => {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser || !currentUser || !currentUser.attributes) return false;

  const createdAt = moment(currentUser.attributes.createdAt);
  if (createdAt.isBefore(MEMBERSHIP_CUTOFF_DATE)) return false;
  return currentUser.attributes?.profile?.protectedData?.membership_active !== true;
};
